import { Link } from 'react-router-dom';
import { Controller, useForm } from 'react-hook-form';
import { useLoginStore } from '@lib/store';
import { LocalStorageUtils, RoutePaths } from '@shared/utils';
import { ButtonV2, Checkbox, Input } from '@shared/widgets';

interface IForm {
  userName: string;
  password: string;
  remember: boolean;
}

interface ILoginProps {
  className?: string;
}

export const LoginForm = (props: ILoginProps) => {
  const loginStore = useLoginStore();

  const formControl = useForm<IForm>({
    mode: 'onChange',
    defaultValues: {
      userName: LocalStorageUtils.getUserName(),
      password: '',
      remember: false,
    },
  });
  const userName = formControl.watch('userName');
  const password = formControl.watch('password');
  const remember = formControl.watch('remember');

  const onSubmit = () => {
    loginStore.login({ Login: userName, Password: password });
    if (remember) LocalStorageUtils.setUserName(userName);
  };

  return (
    <div className={props.className}>
      <form className='flex flex-col' onSubmit={formControl.handleSubmit(onSubmit)}>
        <Controller
          name='userName'
          control={formControl.control}
          rules={{ maxLength: 100 }}
          render={({ field }) => <Input {...field} name='User Name' placeholder='USERNAME' />}
        />
        <Controller
          name='password'
          control={formControl.control}
          rules={{ maxLength: 100 }}
          render={({ field }) => <Input {...field} className='mt-4' name='Password' type='password' placeholder='PASSWORD' />}
        />
        <Controller
          name='remember'
          control={formControl.control}
          rules={{ maxLength: 100 }}
          render={({ field: { value, onChange } }) => (
            <div className='mt-8 mb-11 uppercase'>
              <Checkbox title='Remember my username' checked={value} onChange={onChange} />
            </div>
          )}
        />
        <ButtonV2 type='submit' className='!h-[56px]' disabled={!userName || !password}>
          Login
        </ButtonV2>
      </form>
      <div className='mt-7 mb-10.5 text-center'>
        <Link
          to={RoutePaths.recovery.onNavigate()}
          className='cursor-pointer text-sm text-[#ffffff80] uppercase transition-colors duration-200 hover:text-[#f2f2f2]'
        >
          Have you forgotten your password?
        </Link>
      </div>
      {/* <Link to={RoutePaths.applyNow.onNavigate()}>
        <ButtonV2 className='!h-[56px]' fullWidth color='outlined'>
          Apply Now
        </ButtonV2>
      </Link> */}
    </div>
  );
};
